<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		apisettings,
	} from "@/api/api.js";
	export default {
		name: 'App',
		components: {

		},
		mounted() {
			this.getapisettings()
		},
		methods: {
			// 配置
			getapisettings() {
				apisettings().then((res) => {
					if (res.code == 200) {
						document.title = res.data.systemName
					}
				})
			},
		}
	}
</script>

<style>
	.el-message {
		z-index: 100000002 !important;
	}

	* {
		margin: 0;
		padding: 0;
	}

	.emptybox {
		width: 100%;
		height: 500px;
		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.emptybox>img {
		width: 300px;
		height: 300px;
	}

	.emptybox>div {
		margin-top: 10px;
	}
</style>